import React from "react";
import { ValueContainerRenderer } from "../../types";
import { SEARCHABLE_ENTITY_MODE } from "../../utils";
import {
  StyledTooltipWrapper,
  StyledTooltipDateTitle,
  StyledTooltipGamesContainer,
  StyledTooltipGameItemContainer,
  StyledTag,
} from "../../components/SelectValueContainer.styled";
import { EntitiesGroup } from "../../../DropdownGameItem/components/Entity";
import { formatDate } from "../../utils";

const EntityMatchValueRenderer: ValueContainerRenderer<
  typeof SEARCHABLE_ENTITY_MODE.ENTITIES_MATCH
> = {
  renderTooltipContent: (values) => {
    // Calculate largerGap within this renderer since it's only relevant here
    const allValues = Object.values(values).flatMap((v) => v.items);
    const largerGap = allValues.some((item) =>
      item.groups.some((group) => group.entities.length > 1),
    );

    return (
      <StyledTooltipWrapper>
        {Object.values(values).map((valueGroup) => (
          <React.Fragment key={`index_${valueGroup.date}`}>
            <StyledTooltipDateTitle>
              {formatDate(valueGroup.date)}
            </StyledTooltipDateTitle>
            <StyledTooltipGamesContainer $largerGap={largerGap}>
              {valueGroup.items.map((item) => (
                <StyledTooltipGameItemContainer key={`item_${item.label}`}>
                  {item.groups.map((group, groupIndex) => (
                    <EntitiesGroup
                      key={`${item.label}_group_${groupIndex}`}
                      entities={group.entities}
                      score={group.score}
                    />
                  ))}
                </StyledTooltipGameItemContainer>
              ))}
            </StyledTooltipGamesContainer>
          </React.Fragment>
        ))}
      </StyledTooltipWrapper>
    );
  },

  renderTagContent: (values, tagTitle) => {
    if (values.length > 1) {
      return (
        <StyledTag label={`${tagTitle}: ${values.length}`} tagSize="big" />
      );
    } else {
      return <StyledTag label={values[0].label} tagSize="big" />;
    }
  },
};

export default EntityMatchValueRenderer;
